export default __webpack_public_path__ + "static/media/022.0dde828e.jpg";